import { ReactElement, ReactNode } from 'react';

import { IHospitalDetails, IHospitalHistoryItem } from '~/services/api/hospital/types';
import Item from './Item';

import styles from './HistoryList.module.scss';

interface IProps {
  items: IHospitalHistoryItem[];
  expandedItemId: number | null;
  loadingDetailsIds: number[];
  detailsByHistoryId: Record<number, IHospitalDetails>;
  onAccordionChange: (item: IHospitalHistoryItem, isExpanded: boolean) => void;
  renderAccordionDetails: (
    historyDetails: IHospitalDetails | null,
    isDetailsLoading: boolean,
  ) => ReactNode;
}

const HistoryList = ({
  items,
  expandedItemId,
  loadingDetailsIds,
  detailsByHistoryId,
  onAccordionChange,
  renderAccordionDetails,
}: IProps): ReactElement => (
  <div className={styles.accordionList}>
    {items.map(item => {
      const historyDetails = item.id ? detailsByHistoryId[item.id] : null;
      const isDetailsLoading = item.id ? loadingDetailsIds.includes(item.id) : false;

      return (
        <Item
          key={item.id}
          item={item}
          historyDetails={historyDetails}
          isExpanded={expandedItemId === item.id}
          onAccordionChange={onAccordionChange}
        >
          {renderAccordionDetails(historyDetails, isDetailsLoading)}
        </Item>
      );
    })}
  </div>
);

export default HistoryList;
